import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { userSelector } from "../../state/slices/user-slice";
import { postLoginRedirect } from "../../customer";
import { loadPreferences } from "../../services/preferences-rpc-client";

/**
 * Loads the signed-in user's preferences whenever the user changes (a page
 * reload with a stored session, a re-login), so favorites and the demo-pages
 * toggle apply everywhere. Renders nothing.
 */
export function PreferencesLoader() {
  const userUid = useSelector(userSelector)?.uid;
  useEffect(() => {
    if (userUid) void loadPreferences();
  }, [userUid]);
  return null;
}

/** `/`: wait for the user's preferences, then go to their default page. */
export function HomeRedirect() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let live = true;
    void loadPreferences().then(() => live && setReady(true));
    return () => {
      live = false;
    };
  }, []);
  return ready ? <Navigate to={postLoginRedirect()} replace /> : null;
}
